export default __webpack_public_path__ + "static/media/advantageIcon4.a053af6d.png";